'use client'
import { useState } from "react";
import { ChevronDown, ChevronUp } from "@/assets/icons";
import { Button, SmartLink } from "@/components/ui";

export function MenuSegments() {
    const [menuSegmentsOpen, setMenuSegmentsOpen] = useState<boolean>(false);

    return (
        <div>
            <Button onClick={() => setMenuSegmentsOpen(menuSegmentsOpen ? false : true)} className="flex gap-2 items-center hover:scale-105 hover:text-dark_accent dark:hover:text-light_accent">
                Segmentos
                <ChevronDown className={`size-6 ${menuSegmentsOpen ? 'hidden' : 'flex'}`} />
                <ChevronUp className={`size-6 ${menuSegmentsOpen ? 'flex' : 'hidden'}`} />
            </Button>

            <div className={`${menuSegmentsOpen ? 'flex' : 'hidden'}`}>

                <div className="absolute flex flex-col mt-6 -ms-3 z-50 p-8 gap-6 rounded-md shadow-lg bg-silver-100 dark:bg-silver-500">
                    <SmartLink type="external" route="segmentsSto" onClick={() => setMenuSegmentsOpen(false)}
                        className="flex gap-2 items-center hover:scale-105 hover:text-dark_accent dark:hover:text-light_accent">
                        Varejo
                    </SmartLink>
                    <SmartLink type="external" route="segmentsSer" onClick={() => setMenuSegmentsOpen(false)}
                        className="flex gap-2 items-center hover:scale-105 hover:text-dark_accent dark:hover:text-light_accent">
                        Serviços
                    </SmartLink>
                    <SmartLink type="external" route="segmentsFac" onClick={() => setMenuSegmentsOpen(false)}
                        className="flex gap-2 items-center hover:scale-105 hover:text-dark_accent dark:hover:text-light_accent">
                        Industria
                    </SmartLink>
                    <SmartLink type="external" route="segmentsDis" onClick={() => setMenuSegmentsOpen(false)}
                        className="flex gap-2 items-center hover:scale-105 hover:text-dark_accent dark:hover:text-light_accent">
                        Distribuidora
                    </SmartLink>
                    <SmartLink type="external" route="segmentsRur" onClick={() => setMenuSegmentsOpen(false)}
                        className="flex gap-2 items-center hover:scale-105 hover:text-dark_accent dark:hover:text-light_accent">
                        Produtor Rural
                    </SmartLink>
                </div>
                <div onClick={() => setMenuSegmentsOpen(false)} className="absolute w-screen h-screen top-0 left-0 z-30 cursor-pointer" />
            </div>
        </div>
    )
}